import React from 'react';
import { motion } from 'framer-motion';
import { OrderType } from '../../hooks/useCheckoutForm';

interface OrderTypeTabsProps {
  activeTab: OrderType;
  onTabChange: (tab: OrderType) => void;
  showDelivery: boolean;
}

export const OrderTypeTabs: React.FC<OrderTypeTabsProps> = ({
  activeTab,
  onTabChange,
  showDelivery,
}) => {
  if (!showDelivery) {
    return (
      <div className="border-b border-gray-200 px-6 py-4 bg-gray-50">
        <h3 className="font-semibold text-gray-700">Pickup</h3>
      </div>
    );
  }

  return (
    <div className="relative border-b border-gray-200 bg-gray-100 p-1">
      {/* Animated Slider Background */}
      <motion.div
        className="absolute top-1 bottom-1 w-[calc(50%-0.25rem)] bg-red-500 rounded-lg shadow-md"
        initial={false}
        animate={{
          x: activeTab === 'delivery' ? 'calc(100% + 0.5rem)' : '0%',
        }}
        transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30,
        }}
      />
      
      {/* Tab Buttons */}
      <div className="relative flex gap-2">
        <button
          type="button"
          onClick={() => onTabChange('pickup')}
          className={`flex-1 py-3 px-6 text-center font-semibold z-10 transition-colors duration-200 rounded-lg ${
            activeTab === 'pickup' ? 'text-white' : 'text-gray-600 hover:text-gray-800'
          }`}
        >
          Pickup
        </button>
        <button
          type="button"
          onClick={() => onTabChange('delivery')}
          className={`flex-1 py-3 px-6 text-center font-semibold z-10 transition-colors duration-200 rounded-lg ${
            activeTab === 'delivery' ? 'text-white' : 'text-gray-600 hover:text-gray-800'
          }`}
        >
          Delivery
        </button>
      </div>
    </div>
  );
};
